var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { ExportingTreeSearch } from './ExportingTreeSearch';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { flatten, uniq } from '../../../../utils/helper/lodash_replacements';
export class ExportingTree {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get exportingSearch() {
        return new ExportingTreeSearch(this);
    }
    get allExportingActors() {
        return this.actor.exportingTreeNode.allNodes;
    }
    get allAspectsWithTraits() {
        return uniq(flatten(this.allExportingActors.map(actor => actor.actorAspects.aspectsWithTraits)));
    }
    // @cachedSet
    get allExportingAspects() {
        return this.allAspectsWithTraits.filter(aspect => aspect.exports.length > 0);
    }
    get allExportedTraitsOfExportingActors() {
        return uniq(flatten(this.allExportingAspects.map(aspect => aspect.traits)));
    }
    get allTraitsOfExportingActors() {
        return uniq(flatten(this.allAspectsWithTraits.map(aspect => aspect.traits)));
    }
}
__decorate([
    memoize
], ExportingTree.prototype, "exportingSearch", null);
__decorate([
    cachedSet
], ExportingTree.prototype, "allExportingActors", null);
__decorate([
    cachedSet
], ExportingTree.prototype, "allExportedTraitsOfExportingActors", null);
